import { Observable, rx } from '@shared/rx';
import {
  makeOnControlChangedOperator,
  IOnControlChangedOperator,
  IValueMakers,
} from './on-control-changed-base';

const valueMakers: IValueMakers<boolean> = {
  withDefaultValue: (control): Observable<boolean> =>
    control.statusChanges.pipe(
      rx.startWith(control.invalid),
      rx.map(() => control.invalid),
      rx.distinctUntilChanged(),
    ),
  noDefaultValue: (control): Observable<boolean> =>
    control.statusChanges.pipe(
      rx.map(() => control.invalid),
      rx.distinctUntilChanged(),
    ),
};

export const onControlIsInvalidChanged: IOnControlChangedOperator<boolean> =
  makeOnControlChangedOperator(valueMakers);
